import React from 'react';
import { FilterType } from '../../../models/filter';
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel
} from '@headlessui/react';
import { MinusSmIcon, PlusSmIcon } from '@heroicons/react/solid';
import { ICategory } from '../../../models';
import { useTranslation } from 'react-i18next';
import SubCategoryFilter from './SubCategoryFilter';

const CategoryFilter = ({
  categories = [],
  countCategories = {},
  mobile,
  ui
}: {
  categories: ICategory[];
  countCategories: { [key: string]: number };
  mobile?: boolean;
  ui?: string;
}) => {
  const { t } = useTranslation();

  return (
    <Disclosure
      as="div"
      className={`border-t px-4 py-6 ${
        ui ? 'border-white border-opacity-40' : 'border-black border-opacity-20'
      }`}
    >
      {({ open }) => (
        <>
          <h3 className="-mx-2 -my-3 flow-root">
            <DisclosureButton
              className={`${mobile ? 'bg-white' : ''} ${
                !mobile && ui ? 'text-white' : 'text-black'
              } px-2 py-3  w-full flex items-center justify-between opacity-60 hover:opacity-100`}
            >
              <span className="font-bold">
                {t(`FILTERS.${FilterType.Category}`)}
              </span>
              <span className="ml-6 flex items-center">
                {open ? (
                  <MinusSmIcon className="h-5 w-5" aria-hidden="true" />
                ) : (
                  <PlusSmIcon className="h-5 w-5" aria-hidden="true" />
                )}
              </span>
            </DisclosureButton>
          </h3>
          <DisclosurePanel>
            <div className="my-6 max-h-56 overflow-y-auto">
              {categories.map(category =>
                category.count && category.count > 0 ? (
                  <SubCategoryFilter
                    key={category.id_category}
                    category={category}
                    mobile={mobile}
                    ui={ui}
                  />
                ) : null
              )}
            </div>
          </DisclosurePanel>
        </>
      )}
    </Disclosure>
  );
};

export default CategoryFilter;
